import { useState, useCallback } from 'react';
import Navbar from '@/components/feature/Navbar';
import HeroBanner from './components/HeroBanner';
import FruitCategories from './components/FruitCategories';
import CustomerReviews from './components/CustomerReviews';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export interface SelectedItem {
  id: string;
  fruitName: string;
  weight: string;
  price: string;
  quantity: number;
}

const HomePage = () => {
  const [selectedItems, setSelectedItems] = useState<SelectedItem[]>([]);

  const handleSelectItem = useCallback((item: SelectedItem) => {
    setSelectedItems((prev) => {
      const exists = prev.find((p) => p.id === item.id);
      if (exists) {
        return prev.map((p) => p.id === item.id ? { ...p, quantity: p.quantity + 1 } : p);
      }
      return [...prev, { ...item, quantity: 1 }];
    });
  }, []);

  const handleRemoveItem = useCallback((id: string) => {
    setSelectedItems((prev) => prev.filter((p) => p.id !== id));
  }, []);

  const handleUpdateQuantity = useCallback((id: string, delta: number) => {
    setSelectedItems((prev) =>
      prev
        .map((p) => p.id === id ? { ...p, quantity: p.quantity + delta } : p)
        .filter((p) => p.quantity > 0)
    );
  }, []);

  const handleClearItems = useCallback(() => {
    setSelectedItems([]);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroBanner />
        <FruitCategories onSelectItem={handleSelectItem} selectedItems={selectedItems} />
        <CustomerReviews />
        <ContactForm
          selectedItems={selectedItems}
          onRemoveItem={handleRemoveItem}
          onUpdateQuantity={handleUpdateQuantity}
          onClearItems={handleClearItems}
        />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
